import { render, staticRenderFns } from "./postingLaws.vue?vue&type=template&id=f0ff8716"
import script from "./postingLaws.vue?vue&type=script&lang=js"
export * from "./postingLaws.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports